<template>
  <main class="p-4 pt-14 lg:pt-24 min-h-screen" v-if="page">
    <k-layout :content="page.layout" />
  </main>
</template>

<script>
const KLayout = () =>
  import(/* webpackChunkName: "KLayout" */ "@/components/Layout.vue");
export default {
  name: "about",
  metaInfo() {
    return {
      title: "– " + this.page.title,
    };
  },
  components: {
    KLayout,
  },
  computed: {
    page() {
      return this.$store.state.pages[this.$route.name];
    },
  },
};
</script>
